<!-- 2.17 报表增加-进货台账 -->
<!-- 进货台账 -->

<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true" size="medium">
          <el-form-item label="副仓：" v-if="subWarehouseList && subWarehouseList.length > 1">
            <el-select v-model="searchForm.SUB_WAREHOUSE" filterable placeholder="请选择副仓" clearable multiple style="width: 200px;">
              <el-option v-for="item in subWarehouseList" :key="item.ID" :label="item.AB_NAME" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="单品名称：">
            <el-input v-model="searchForm.PRODUCT_NAME" placeholder="请输入产品名称"></el-input>
          </el-form-item>
          <el-form-item label="产品编码：">
            <el-input v-model="searchForm.PRODUCT_CODE" placeholder="请输入产品编码"></el-input>
          </el-form-item>
          <el-form-item label="自有分类：" v-if="this.是否使用自有分类 == 0">
            <el-select size="medium" v-model="searchForm.CATE_ID" clearable filterable>
              <el-option v-for="item in catalogList" :key="item.ID" :label="item.CATALOG_NAME" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="系统分类：" v-if="this.是否使用自有分类 == 1">
            <el-select size="medium" v-model="searchForm.CATE_CODE" clearable filterable>
              <el-option v-for="item in firstTypeList" :key="item.INNER_CODE" :label="item.NAME" :value="item.INNER_CODE">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="进货日期范围：">
            <el-date-picker unlink-panels v-model="searchForm.SEND_DATE_RANGE" type="daterange" range-separator="至" clearable start-placeholder="开始日期"
              end-placeholder="结束日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="入库日期范围：">
            <el-date-picker unlink-panels v-model="searchForm.DATE_RANGE" type="daterange" range-separator="至" clearable start-placeholder="开始日期"
              end-placeholder="结束日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col>
        <el-button type="primary" @click="筛选()">筛选</el-button>
        <el-button type="primary" @click="导出()">导出</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 5px">
      <el-col>
        <el-table :data="处理后的数据" max-height="650" stripe border :span-method="objectSpanMethod">
          <el-table-column label="产品名称" prop="NAME" min-width="100px"></el-table-column>
          <el-table-column label="产品编码" prop="PRODUCT_CODE" min-width="100px"></el-table-column>
          <el-table-column label="批次" prop="BATCH" min-width="100px"></el-table-column>
          <el-table-column label="产品分类" prop="FCNAME" min-width="100px"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT" min-width="100px"></el-table-column>
          <el-table-column label="规格" prop="SPECIFICATION" min-width="100px"></el-table-column>
          <el-table-column label="采购日期" prop="SEND_DAY" min-width="100px"></el-table-column>
          <el-table-column label="入库日期" prop="CREATE_TIME" min-width="100px"></el-table-column>
          <el-table-column label="入库数量" prop="REAL_COUNT" min-width="100px"></el-table-column>
          <el-table-column label="采购退货数量" prop="RETURN_COUNT" min-width="100px"></el-table-column>

          <el-table-column label="生产日期" prop="PRODUCTION_DATE" min-width="100px"></el-table-column>
          <el-table-column label="产地" prop="PRODUCING_AREA" min-width="100px"></el-table-column>
          <el-table-column label="生产单位" prop="SOURCE_COMPANY" min-width="100px"></el-table-column>
          <el-table-column label="供应商信息" prop="SUPPLIER_NAME" min-width="100px"></el-table-column>
          <el-table-column label="联系人" prop="CONTACT_PERSON" min-width="100px"></el-table-column>
          <el-table-column label="联系电话" prop="CONTACT_PHONE" min-width="100px"></el-table-column>
          <el-table-column label="团餐公司" prop="TC_NAME" min-width="100px"></el-table-column>
          <el-table-column label="项目点" prop="PROJECT_NAME" min-width="100px"></el-table-column>
          <el-table-column label="档口名称" prop="DK_NAME" min-width="100px"></el-table-column>
          <el-table-column label="出库数量" prop="OUT_COUNT" min-width="100px"></el-table-column>
          <el-table-column label="出库退货数量" prop="OUT_RETURN_COUNT" min-width="100px"></el-table-column>
          <el-table-column label="出库时间" prop="OUT_TIME" min-width="100px"></el-table-column>
          <el-table-column label="操作" fixed="right" min-width="120px">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="下载批次报告(scope.row)">下载批次报告</el-button>
            </template>

          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div class="pagination_box" style="text-align: right">
      <el-pagination @current-change="queryData" :current-page.sync="currentPage" :page-size="pageSize" layout="total,prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { getClassFun } from 'api/skuManage';
import { downloadBatchReport } from 'api/shopOrderManage';
import { queryFirstFun } from 'api/warehouseManager';
import http from '@/assets/common/http';
import date from '@/assets/common/date';

export default {
  data() {
    return {
      处理后的数据: [],
      searchForm: {
        SEND_DATE_RANGE: [date(new Date(), '%F'), date(new Date(), '%F')],

      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      catalogList: [],
      是否使用自有分类: 0,
      spanArr: [],
      subWarehouseList: JSON.parse(sessionStorage.getItem('subWarehouseList')),
      firstTypeList: [],
    };
  },
  computed: {
    进货台账存储数据() {
      return this.$store.state.进货台账存储数据;
    },
  },
  created() {
    if (this.进货台账存储数据) {
      this.searchForm = this.进货台账存储数据.CONDITION;
      this.currentPage = this.进货台账存储数据.CURRENT_PAGE;
    }
    // 0自有分类 1 默认分类
    if (sessionStorage.getItem('是否使用自有分类') == 0) {
      this.是否使用自有分类 = 0;
      this.queryCatalog();
    } else {
      this.是否使用自有分类 = 1;
      this.拉取系统分类();
    }
    this.queryData();
  },
  methods: {
    objectSpanMethod({
      row, column, rowIndex, columnIndex,
    }) {
      if (columnIndex < 15) {
        let rowspan = 1;
        const 出库ID = row.ID;
        while (rowIndex + rowspan < this.处理后的数据.length
        && this.处理后的数据[rowIndex + rowspan].ID === 出库ID) {
          rowspan++;
        }
        if (rowIndex === 0 || this.处理后的数据[rowIndex - 1].ID !== 出库ID) {
          return { rowspan, colspan: 1 };
        }
        return { rowspan: 0, colspan: 1 };
      }
    },
    拉取系统分类() {
      const params = {
      };
      queryFirstFun(params)
        .then((result) => {
          if (result[0]) {
            this.firstTypeList = result.filter((item) => item.NAME != '全部');
          } else {
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    下载批次报告(row) {
      if (row.BATCH_REPORT_ID == 0) {
        this.$message.show({ text: '该商品没有批次报告', type: 'warning' });
        return false;
      }
      const params = {
        BATCH_REPORT_ID: row.BATCH_REPORT_ID,
      };
      downloadBatchReport(params).then((result) => {
        window.open(this.$util.getURLLocalHost(result[0].FILE_PATH), 'file');
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    queryCatalog() {
      const params = {};
      getClassFun(params).then((result) => {
        if (result.length !== 0) {
          this.catalogList = result;
        } else {
          this.catalogList = [];
        }
      })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    导出() {
      const params = {
        SERVICE_ID: '10031',
        OTYPE: 481,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.SUB_WAREHOUSE && this.searchForm.SUB_WAREHOUSE[0]) {
        params.GYS_ID_LIST = this.searchForm.SUB_WAREHOUSE;
      }
      if (this.searchForm.PRODUCT_NAME) params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      if (this.searchForm.PRODUCT_CODE) params.PRODUCT_CODE = this.searchForm.PRODUCT_CODE;
      // 入库日期
      if (this.searchForm.DATE_RANGE && this.searchForm.DATE_RANGE[0]) {
        params.START_DATE = this.searchForm.DATE_RANGE[0];
        params.END_DATE = this.searchForm.DATE_RANGE[1];
      }
      if (this.searchForm.SEND_DATE_RANGE && this.searchForm.SEND_DATE_RANGE[0]) {
        params.START_SEND_DAY = this.searchForm.SEND_DATE_RANGE[0];
        params.END_SEND_DAY = this.searchForm.SEND_DATE_RANGE[1];
      }
      http.post(params).then((result) => {
        if (result[0] && result[0].FILE_PATH) {
          window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        } else if (result[0] && result[0].TASK_CREATED_SUCCESSFULLY) {
          this.$util.getUnreadInformation(this);
          this.$confirm(this.$util.appointmentMessage, '温馨提示', {
            confirmButtonText: '确定', cancelButtonText: '取消', type: 'success', dangerouslyUseHTMLString: true,
          }).then(() => {
            this.$router.push({ name: 'appointmentHandling' });
          }).catch(() => {
            this.$message.show({ type: 'info', text: '取消操作' });
          });
        } else {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    筛选() {
      this.currentPage = 1;
      this.queryData();
    },
    queryData() {
      const params = {
        SERVICE_ID: '10031',
        OTYPE: 480,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.SEND_DATE_RANGE != null && this.searchForm.SEND_DATE_RANGE.length == 2) {
        if ((new Date(this.searchForm.SEND_DATE_RANGE[1]) - new Date(this.searchForm.SEND_DATE_RANGE[0])) / 86400000 > 31) {
          this.$message.show({ text: '选择的日期范围请不要大于31天', type: 'warning' });
          return;
        }

        params.START_SEND_DAY = this.searchForm.SEND_DATE_RANGE[0];
        params.END_SEND_DAY = this.searchForm.SEND_DATE_RANGE[1];
      }
      if (this.searchForm.SUB_WAREHOUSE && this.searchForm.SUB_WAREHOUSE[0]) {
        params.GYS_ID_LIST = this.searchForm.SUB_WAREHOUSE;
      }
      if (this.searchForm.CATE_ID && this.是否使用自有分类 == 0) params.CATE_ID = this.searchForm.CATE_ID;
      if (this.searchForm.CATE_CODE && this.是否使用自有分类 == 1) params.CATE_CODE = this.searchForm.CATE_CODE;
      if (this.searchForm.PRODUCT_NAME) params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      if (this.searchForm.PRODUCT_CODE) params.PRODUCT_CODE = this.searchForm.PRODUCT_CODE;
      // 入库日期
      if (this.searchForm.DATE_RANGE && this.searchForm.DATE_RANGE[0]) {
        params.START_DATE = this.searchForm.DATE_RANGE[0];
        params.END_DATE = this.searchForm.DATE_RANGE[1];
      }
      http.post(params).then((res) => {
        this.tableData = res[0].OP_ROLE;
        this.totalCount = res[0].TOTAL_COUNT;
        this.$store.dispatch('设置进货台账存储数据', {
          CONDITION: this.searchForm,
          CURRENT_PAGE: this.currentPage,
        });
        this.处理数据();
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    处理数据() {
      this.处理后的数据 = [];
      this.tableData.forEach((item) => {
        if (item.OUT_DATA && item.OUT_DATA.length > 0) {
          item.OUT_DATA.forEach((outItem) => {
            const { BATCH: OUT_BATCH, ...restOutItem } = outItem;
            const newRow = { ...item, ...restOutItem, OUT_BATCH };
            this.处理后的数据.push(newRow);
          });
        } else {
          this.处理后的数据.push(item);
        }
      });
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/tableManage/purchaseLedger.vue